import { User as FirestoreUser } from '@angular/fire/auth';

export interface IUser {
  displayName: string;
  email: string;
  uid: string;
}

export class User implements IUser {
  displayName = '';
  email = '';
  uid = '';
  user: FirestoreUser;

  // Need to remember to change FirestoreUser here if we ever change backend infrastructure.
  constructor(user: FirestoreUser) {
    this.email = user.email ?? '';
    this.displayName = user.displayName ?? '';
    this.uid = user.uid ?? '';
    this.user = user;
  }

  getIdToken() {
    return this.user.getIdToken(); // uses the Firebase (not firestore) Auth method to get the ID token
  }
}
